import React from 'react'
import { Image, Label, Button } from 'semantic-ui-react'
import './Guide.scss'
import Search from '../../assets/search.png'
import { withRouter } from 'react-router'

const Guide1 = props => {

    const goToSignIn = () => {
        props.history.push('/signin')
    }

    const goToGuideFinal = () => {
        props.history.push('/guide/final')
    }

    return (
        <div className='guide'>
            <h1 >Siempre en tu navegador</h1>
            <Label style={{ color: '#606060' }}>Acceda a su perfil de Shield en cualquier momento haciendo click en el icono de su navegador</Label>
            <div className='guide_image'>
                <Image src={Search} />
            </div>

            <Button onClick={goToGuideFinal}>Siguiente</Button>
            <div className='intro'>
                <span onClick={goToSignIn}>Saltar intro</span>

                <div className='carousel'>
                    <div className='carousel_circle' />
                    <div className='carousel_circle' style={{ backgroundColor: '#68bbe3' }} />
                    <div className='carousel_circle' />
                    <div className='carousel_circle' />
                </div>
            </div>
        </div>
    )
}

export default withRouter(Guide1)
